module.exports = __webpack_public_path__ + "img/cf.1b78ddbc.svg";